module.exports = __webpack_public_path__ + "static/img/spread1-3.36eda03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/spread1-3.jpg
// module id = CvMJ
// module chunks = 1